export default __webpack_public_path__ + "static/media/peleando.e6f7ec4c.png";